export const domainConsultationPlan = {
    id: "domain-consultation",
    name: "Domain Consultation",
    price: 0,
    description: "Schedule a free consultation to choose your perfect domain.",
    whmcsPid: 999,
    type: "one-time",
};
